const hasTags = (tags) => {
  return {
    getHasTag(tagGuid) {
      return !!tags.find(tag => tag.tagGuid === tagGuid);
    },
  };
};

export default hasTags;
